$(function(){
   window.map = boldMap
          if (typeof map === 'undefined') {
            return
          }
  if(getCookie('home_store_lat') && getCookie('home_store_lng')){
      map.setZoom(10);
         map.setCenter(new google.maps.LatLng(getCookie('home_store_lat'), getCookie('home_store_lng')));
  }
  geoFindMe(get_new_stores_geo)

});
// jQuery.ajax( {
//   url: '//freegeoip.net/json/',
//  type: 'POST',
//  dataType: 'jsonp',
//  success: function(location) {
//    get_new_stores_geo( location.latitude, location.longitude, 1);
//   },
//   error: function(location) {
//     jQuery("div#addresses_list").show();
//   },
//});


function show_addresses(){
  var html = "";
  var directions ="";
  for(i=0;i<addresses.length;i++){
    var website = "";
    
    var pin_colour = "";
    if(find_directions){
      directions="<div class='directions'><a href='#' onclick='calcRoute("+addresses[i].id+");return false;'>"+getDirections+"</a></div>";
    }
    if(addresses[i].marker_colour != "main"){
      pin_colour = " style='background-image:url(\"/apps/store-locator/markers/"+addresses[i].marker_colour+"2.png\")' ";
    }
    var newData =  $('<div>'+addresses[i].address+'</div>');
    var home_store = getCookie('home_store');
    var store_number = 0;
     newData.find('.custom_fields').find('.custom_field_name').each(function(){
       if($(this).text().indexOf("Store") > -1){
         store_number = $(this).next('span').text();
       }
     });
    if( home_store == store_number){
      var btn = '<button class="bold-make-home-store bold-home-store store-'+store_number+'-btn" onclick="set_home_store(\''+store_number+'\','+addresses[i].id+' , this)">My Home Store</button>'
          html = html + "<li "+pin_colour+" onmouseover='hoverStart("+addresses[i].id+")' onmouseout='hoverStop("+addresses[i].id+")'><div class='distance'>"+addresses[i].distance+"</div><a href='#' onclick='focus_and_popup("+addresses[i].id+"); return false;'>"+addresses[i].address+"</a>" + website + directions +  btn + "</li>";
    }else{
      var btn = '<button class="bold-make-home-store store-'+store_number+'-btn" onclick="set_home_store(\''+store_number+'\','+addresses[i].id+',this)">+ Make Home Store</button>'   
    }
  }
  for(i=0;i<addresses.length;i++){
    var website = "";
    var pin_colour = "";
    if(find_directions){
      directions="<div class='directions'><a href='#' onclick='calcRoute("+addresses[i].id+");return false;'>"+getDirections+"</a></div>";
    }
    if(addresses[i].marker_colour != "main"){
      pin_colour = " style='background-image:url(\"/apps/store-locator/markers/"+addresses[i].marker_colour+"2.png\")' ";
    }
    var newData =  $('<div>'+addresses[i].address+'</div>');
    var home_store = getCookie('home_store');
    var store_number = 0;
     newData.find('.custom_fields').find('.custom_field_name').each(function(){
       if($(this).text().indexOf("Store") > -1){
         store_number = $(this).next('span').text();
       }
     });
    if( home_store == store_number){
      var btn = '<button class="bold-make-home-store bold-home-store store-'+store_number+'-btn"  onclick="set_home_store(\''+store_number+'\','+addresses[i].id+', this)">My Home Store</button>'
      
    }else{
      var btn = '<button class="bold-make-home-store store-'+store_number+'-btn" onclick="set_home_store(\''+store_number+'\','+addresses[i].id+',this)">+ Make Home Store</button>'   
          html = html + "<li "+pin_colour+" onmouseover='hoverStart("+addresses[i].id+")' onmouseout='hoverStop("+addresses[i].id+")'><div class='distance'>"+addresses[i].distance+"</div><a href='#' onclick='focus_and_popup("+addresses[i].id+"); return false;'>"+addresses[i].address+"</a>" + website + directions +  btn + "</li>";

    }
  }
  if(addresses.length == 0){
    html = "<li><div class='no_stores_found'>"+noStoresFound+"</div></li>";
  }
  jQuery("div#addresses_list").show();
  jQuery(".addresses ul").html(html);
  jQuery(".addresses ul").slideDown();
  fixURLS();
}

//overide store locator function 
function focus_and_popup(id){

        var marker;
        var directions ="";
        if(find_directions){
            directions="<div class='directions'><a href='#' onclick='calcRoute("+id+");return false;'>"+getDirections+"</a></div>";
        }

        for(i=0; i<markersArray.length; i++){
            if(markersArray[i].id == id && id > 0){
                marker = markersArray[i];
                map.panTo(marker.getPosition());
                jQuery.getJSON('/apps/store-locator/get_store_info.php?shop=bold14-2.myshopify.com&data=detailed&store_id='+id, function (data){
                    var newData =  $('<div>'+data.data+'</div>');
                    var home_store = getCookie('home_store');
                    var store_number = 0;
                    newData.find('.custom_fields').find('.custom_field_name').each(function(){
                       if($(this).text().indexOf("Store") > -1){
                         store_number = $(this).next('span').text();
                       }
                    });
                    if( home_store == store_number){
                      newData.append('<button class="bold-make-home-store bold-home-store store-'+store_number+'-btn" onclick="set_home_store(\''+store_number+'\','+id+', this)">My Home Store</button>');
                    }else{
                      newData.append('<button class="bold-make-home-store store-'+store_number+'-btn" onclick="set_home_store(\''+store_number+'\','+id+',this)">+ Make Home Store</button>');
                    }                    
                    infoPopup.close();
                    infoPopup.setContent("<div class='gm_popup'>"+newData.html() + directions +"</div>");
                    infoPopup.open(map,marker);
                });
            }else if(markersArray[i].id == id && id == 0){
                marker = markersArray[i];
                map.panTo(marker.getPosition());
                infoPopup.close();
                infoPopup.setContent("<div class='gm_popup'>"+ youAreHere  +"</div>");
                infoPopup.open(map,marker);
            }
        }
    }

 function codeAddress(){
   
        var address = jQuery("#address_search").val();
        if(address == "City Or Postal Code"){
            address="";
        }
        if(address){
           address = address + " Canada";
            geocoder.geocode( { 'address': address}, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    map.setCenter(results[0].geometry.location);
                    find_new_stores(1);
                } else {
                    alert('Error finding your address please review your criteria and try again');
                }
            });
        }else{
            find_new_stores();
        }

    }

function get_new_stores_geo(lat, lng, calc_distance){
  var calc_dist = 0;
  if(calc_distance == 1){
    calc_dist=1;
  }
  var selectboxes = jQuery('select[id^=custom_field_]');
  var cf_url = "";
  for(i=0;i<selectboxes.length;i++){
    var selectbox = selectboxes[i];
    var val = jQuery(selectbox).children("option:selected").text();
    if(val){
      cf_url = cf_url + "&" + encodeURIComponent(selectbox.id) + "=" + encodeURIComponent(val);
    }
  }
  selectboxes = jQuery('input[id^=search_filter_]:checked');
  var sf_url = "";
  var limit = 100;
  var within_distance = 0;
  for(i=0;i<selectboxes.length;i++){
    var selectbox = selectboxes[i];
    sf_url = sf_url + "&" + encodeURIComponent(selectbox.id) + "=1";
  }
  jQuery.getJSON('/apps/store-locator/get_surrounding_stores.php?shop=shopatshowcase.myshopify.com&latitude='+lat+'&longitude='+lng + "&max_distance=" +within_distance + "&limit=" + limit + cf_url + sf_url + '&calc_distance='+calc_dist, set_stores_geo);
//       currentLatLng = new google.maps.LatLng(lat,lng);
   
//   map.setZoom(10);
//  map.panTo(currentLatLng);

}

function set_stores_geo(data){
        find_directions = false;
        markersCoords.length=0;
        addresses.length=0;

        if(data.you){
            markersCoords.push({lat: data.you.lat, lng: data.you.lng, id: 0, address:'', marker_colour:''});
            find_directions=true;
        }

        for(i=0;i<data.stores.length;i++){
            markersCoords.push({lat: data.stores[i].lat, lng: data.stores[i].lng, id: data.stores[i].store_id, address:data.stores[i].summary, marker_colour:data.stores[i].pin_icon});
            addresses.push({id: data.stores[i].store_id, address:data.stores[i].summary, distance: data.stores[i].distance, website: data.stores[i].website, marker_colour:data.stores[i].pin_icon});
        }

        jQuery(".addresses ul").slideUp(show_addresses)
        add_markers_geo();
    }

    function add_markers_geo(){
        end_directions();
        //remove old markers and forget about them
        for(i=0;i<markersArray.length;i++){
            google.maps.event.clearListeners(markersArray[i], 'click');
            markersArray[i].setMap(null);
        }
        markersArray.length=0;
        var bounds = new google.maps.LatLngBounds();

        //add new markers (they are better anyways)
        for(i=0; i<markersCoords.length;i++){
            var myicon = mainIcon;
            var mydrag = false;
            if(markersCoords[i].id ==0){
                myicon = youIcon;
                mydrag = true;
            }else if(markersCoords[i].marker_colour != "main"){
                myicon="/apps/store-locator/markers/"+markersCoords[i].marker_colour+".png";
            }
         
            var myLatlng = new google.maps.LatLng(markersCoords[i].lat,markersCoords[i].lng);
            var marker = new google.maps.Marker({
                position: myLatlng,
                map: map,
                draggable:mydrag,
                animation: google.maps.Animation.DROP,
                id:markersCoords[i].id,
                store_address:markersCoords[i].address,
                icon:myicon,
                shadow:myshadow
            });
          if(i < 5){
            bounds.extend(marker.getPosition());
          }
            if(markersCoords[i].id ==0){
                google.maps.event.addListener(marker, "dragend", function(event) {

                    map.setCenter(event.latLng);
                    find_new_stores(1);

                });
            }

            google.maps.event.addListener(marker, 'click', function() {
                focus_and_popup(this.id);
            });

            markersArray.push(marker);
        }
    
           var map = boldMap
          if (typeof map === 'undefined') {
            return
          }
      map.setZoom(10);
        if(getCookie('home_store_lat') && getCookie('home_store_lng')){
          map.setCenter(new google.maps.LatLng(getCookie('home_store_lat'), getCookie('home_store_lng')));
        }else{
            map.fitBounds(bounds);
        }


    }


function set_home_store(storeNumber, mId, elem){
    setCookie("home_store", storeNumber, 12000);
    setCookie('home_store_lat',getMarkerLatLng(mId).getPosition().lat(),12000);
    setCookie('home_store_lng',getMarkerLatLng(mId).getPosition().lng(),12000);
    $('.bold-make-home-store').removeClass('bold-home-store')
    $('.bold-make-home-store').text('+ Make Home Store')
    $('.store-'+storeNumber+'-btn').addClass('bold-home-store');
    $('.store-'+storeNumber+'-btn').text('My Home Store');
}

function getMarkerLatLng(id){
  for(i=0; i<markersArray.length; i++){
      if(markersArray[i].id == id && id > 0){
        return markersArray[i];
      }
    }
}


